module.exports = __webpack_public_path__ + "28b3b92bd9be2436513973e5b61ab739.svg";